import createAxiosInstance from "@/libs/createAxiosInstance";

const API_URL = process.env.REACT_APP_API_URL!;
if (!API_URL) {
  throw new Error("REACT_APP_API_URL is not defined");
}
export default createAxiosInstance(API_URL);
